import React, { Component } from "react";
import iconPlaySrc from "../img/icon-play.png";
import "./Video.css";

import isEqual from "lodash/isEqual";

export default class Video extends Component {
	state = {
		isPlaying: false,
	};

	handleBtnPlayClick = event => {
		// console.log(`handleBtnPlayClick`);
		this.btnPlay.style.visibility = "hidden";
		this.video.play();
		this.setState({ isPlaying: true });
	};

	handleVideoClick = event => {
		this.video.pause();
		this.setState({ isPlaying: false });
		this.showPlayButton();
	};

	componentWillReceiveProps = nextProps => {
		// console.log(`componentWillReceiveProps`, nextProps);

		if (isEqual(nextProps, this.props) === false) {
			this.setState({ isPlaying: false });
		}
	};

	componentDidUpdate = () => {
		// console.log(`componentDidUpdate`, this.state);
		if (this.state.isPlaying === false) {
			this.showPlayButton();
		}
	};

	componentDidMount = () => {
		document.addEventListener("keypress", this.handleKeypress);
	};

	componentWillUnmount = () => {
		document.removeEventListener("keypress", this.handleKeypress);
	};

	handleKeypress = event => {
		// console.log(event.code);

		if (event.key === " ") {
			if (this.state.isPlaying === false) {
				this.handleBtnPlayClick(null);
			} else {
				this.handleVideoClick();
			}
		}
	};

	showPlayButton = () => {
		this.btnPlay.style.visibility = "visible";
	};

	render() {
		const { poster, src } = this.props;

		return (
			<div className="Video">
				<video
					src={src}
					ref={node => {
						this.video = node;
					}}
					onClick={this.handleVideoClick}
					poster={poster}
					loop
					playsInline
					className="Blur"
				/>
				<button
					className="Play"
					ref={node => {
						this.btnPlay = node;
					}}
					onClick={this.handleBtnPlayClick}
				>
					<img src={iconPlaySrc} alt="Play" />
				</button>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Video.js